﻿import { useNavigate } from "react-router-dom";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { hasPermission } from "@/services/Utils";

const OrderClassificationsTableBody = ({ orders_classification, handleDelete, permissions }) => {
	const navigate = useNavigate();

	return (
		<tbody>
			{orders_classification &&
				orders_classification.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{hasPermission("edit", permissions) && (
										<PencilSvg className={classes.icon} onClick={() => navigate("/configuracion/clasificaciones_oc/editar/" + item.id)} />
									)}
									{hasPermission("delete", permissions) && <RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />}
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default OrderClassificationsTableBody;
